import ExpenseItem from "../ExpenseItems";

import "../Styling/Expenses.css";


function Expenses(exp_Data) {
  const clickHandler = () => {
    console.log("Clicked!!");
  };
 

  return (
    <div className="expenses">
      <h1 className="heading">{exp_Data.expenses[0].heading}</h1>
      <div className="expensesMainBody">
        <ExpenseItem
          title={exp_Data.expenses[1].title}
          desc={exp_Data.expenses[1].desc}
          account={exp_Data.expenses[1].account}
          amount={exp_Data.expenses[0].amount}
          date={exp_Data.expenses[6].date}
        ></ExpenseItem>
        <ExpenseItem
          title={exp_Data.expenses[1].title}
          desc={exp_Data.expenses[1].desc}
          account={exp_Data.expenses[1].account}
          amount={exp_Data.expenses[0].amount}
          date={exp_Data.expenses[6].date}
        ></ExpenseItem>

        
      </div>

      <div className="endOfContent">
        <button className="button" onClick={clickHandler}>
          Add New Card
        </button>
      </div>
    </div>
  );
}

export default Expenses;
